/* HerNext · Look inside — guide switcher, page flip, gentle auto-play */
(function () {
  if (window.__hernextPeek) return;
  window.__hernextPeek = true;
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function init(root) {
    if (root.__pk) return;
    root.__pk = true;
    var tabs = [].slice.call(root.querySelectorAll('.pk-tab'));
    var panels = [].slice.call(root.querySelectorAll('.pk-panel'));
    var tabList = root.querySelector('.pk-tabs');
    if (!tabs.length) return;
    function edge() { if (!tabList) return; tabList.classList.toggle('is-scrollable', tabList.scrollWidth > tabList.clientWidth + 2); tabList.classList.toggle('is-end', tabList.scrollLeft + tabList.clientWidth >= tabList.scrollWidth - 4); }
    if (tabList) { tabList.addEventListener('scroll', edge, { passive: true }); window.addEventListener('resize', edge); edge(); }
    var current = 0;
    var auto = reduce ? 0 : (parseInt(root.getAttribute('data-pk-auto'), 10) || 0) * 1000;
    var stopped = !auto, paused = false, visible = false, timer = null, flipTimer = null;

    function flip(panel, toBack) {
      var pages = panel.querySelectorAll('[data-pk-page]');
      if (pages.length < 2) return;
      var front = panel.querySelector('.pk-page.is-front');
      var showBack = typeof toBack === 'boolean' ? toBack : front === pages[0];
      pages[0].classList.toggle('is-front', !showBack); pages[0].classList.toggle('is-back', showBack);
      pages[1].classList.toggle('is-front', showBack); pages[1].classList.toggle('is-back', !showBack);
      var dots = panel.querySelectorAll('.pk-dots i');
      if (dots.length === 2) { dots[0].classList.toggle('is-on', !showBack); dots[1].classList.toggle('is-on', showBack); }
      var label = panel.querySelector('[data-pk-flip-label]');
      if (label) label.textContent = label.getAttribute(showBack ? 'data-b' : 'data-a');
    }

    function show(i, user) {
      i = (i + tabs.length) % tabs.length;
      tabs.forEach(function (t, k) {
        var on = k === i;
        t.setAttribute('aria-selected', on ? 'true' : 'false');
        t.tabIndex = on ? 0 : -1;
        panels[k].hidden = !on;
        panels[k].classList.toggle('is-active', on);
      });
      flip(panels[i], false);
      current = i;
      // keep the active tab in view without moving the page
      var t = tabs[i];
      if (tabList && tabList.scrollWidth > tabList.clientWidth) {
        var left = t.offsetLeft - (tabList.clientWidth - t.offsetWidth) / 2;
        tabList.scrollTo({ left: Math.max(0, left), behavior: reduce ? 'auto' : 'smooth' });
      }
      if (user) stop();
      else schedule();
    }

    function stop() { stopped = true; clearTimeout(timer); clearTimeout(flipTimer); }
    function schedule() {
      clearTimeout(timer); clearTimeout(flipTimer);
      if (stopped || paused || !visible) return;
      flipTimer = setTimeout(function () { flip(panels[current], true); }, auto * 0.55);
      timer = setTimeout(function () { show(current + 1, false); }, auto);
    }

    tabs.forEach(function (t, i) {
      t.addEventListener('click', function () { show(i, true); });
      t.addEventListener('keydown', function (e) {
        var d = e.key === 'ArrowRight' ? 1 : e.key === 'ArrowLeft' ? -1 : 0;
        if (!d) return;
        e.preventDefault(); show(current + d, true); tabs[current].focus();
      });
    });

    panels.forEach(function (p) {
      var btn = p.querySelector('[data-pk-flip]');
      if (btn) btn.addEventListener('click', function () { stop(); flip(p); });
      var stack = p.querySelector('.pk-stack');
      if (stack) {
        stack.addEventListener('click', function () { stop(); flip(p); });
        var x0 = null;
        stack.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; }, { passive: true });
        stack.addEventListener('touchend', function (e) {
          if (x0 === null) return;
          var dx = e.changedTouches[0].clientX - x0; x0 = null;
          if (Math.abs(dx) > 40) { stop(); show(current + (dx < 0 ? 1 : -1), true); }
        }, { passive: true });
      }
    });

    root.addEventListener('mouseenter', function () { paused = true; clearTimeout(timer); clearTimeout(flipTimer); });
    root.addEventListener('mouseleave', function () { paused = false; schedule(); });
    root.addEventListener('focusin', function () { paused = true; clearTimeout(timer); clearTimeout(flipTimer); });

    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (es) { visible = es[0].isIntersecting; if (visible) schedule(); else { clearTimeout(timer); clearTimeout(flipTimer); } }, { threshold: 0.35 }).observe(root);
    } else { visible = true; schedule(); }

    // Theme editor: selecting a block shows that guide
    root.addEventListener('shopify:block:select', function (e) {
      var i = tabs.indexOf(e.target.closest ? e.target.closest('.pk-tab') : null);
      if (i > -1) show(i, true);
    });
  }

  function boot() { document.querySelectorAll('[data-pk]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();
